import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { HospitalConfiguracaoOperadora, ConvenioConfiguracaoOperadora, ProcedimentoConfiguracaoOperadora } from '@/types/_'
import { IntegracaoOperadora } from '@/types/core'
import { generateGUID } from '@/utils/common'

@Module({ namespaced: true, name: 'ConfigIntegracaoOperadoraStore' })
export default class ConfigIntegracaoOperadoraStore extends VuexModule {
  private integracaoOperadoraImp: IntegracaoOperadora.IIntegracaoOperadora = new IntegracaoOperadora.IntegracaoOperadora()
  private hospitalConfiguracaoOperadoraDefault: HospitalConfiguracaoOperadora = {
    consultaAutorizacao: false,
    consultaElegibilidade: false,
    hospitalFazIntegracaoOperadora: false,
    token: '',
    id: '',
  }

  public hospitalConfiguracaoOperadora: HospitalConfiguracaoOperadora = { ...this.hospitalConfiguracaoOperadoraDefault }
  public hospitalId: string = ''
  public operadoras: any[] = []
  public procedimento: any = {}
  public mode: string = 'CREATE'
  public operadoraDefault: ConvenioConfiguracaoOperadora = {
    nome: '',
    consultaAutorizacao: false,
    consultaElegibilidade: false,
    consultaAutorizacaoSolicitacaoComOpme: false,
    sugereDataAtualParaDataReferencia: false,
    convenioId: '',
    enviaCodigoProcedimentoInternacao: false,
    hospitalId: '',
    codigoOperadora: '',
    procedimentos: [],
    enviaCodigoPrestadorSolicitante: false,
    enviaCodigoUnicoMaterial: false,
    tiposDocumentoParaEnviarParaOperadora: [],
  }

  public operadora: ConvenioConfiguracaoOperadora = { ...this.operadoraDefault }

  @Mutation
  setMode(value: string) {
    this.mode = value
  }

  @Mutation
  setHospitalConfiguracaoOperadora(value: HospitalConfiguracaoOperadora) {
    this.hospitalConfiguracaoOperadora = value
  }

  @Mutation
  setHospital(id: string) {
    this.hospitalId = id
  }

  @Mutation
  setOperadora(item: any) {
    if (item.nome) this.operadora.nome = item.nome
    if (item.consultaAutorizacao) this.operadora.consultaAutorizacao = item.consultaAutorizacao
    if (item.codigoOperadora) this.operadora.codigoOperadora = item.codigoOperadora
    if (item.sugereDataAtualParaDataReferencia) this.operadora.sugereDataAtualParaDataReferencia = item.sugereDataAtualParaDataReferencia
    if (item.consultaElegibilidade) this.operadora.consultaElegibilidade = item.consultaElegibilidade
    if (item.consultaAutorizacaoSolicitacaoComOpme) this.operadora.consultaAutorizacaoSolicitacaoComOpme = item.consultaAutorizacaoSolicitacaoComOpme
    if (item.enviaCodigoProcedimentoInternacao) this.operadora.enviaCodigoProcedimentoInternacao = item.enviaCodigoProcedimentoInternacao
    if (item.hospitalId) this.operadora.hospitalId = item.hospitalId
    if (item.convenioId) this.operadora.convenioId = item.convenioId
    if (item.procedimentos && item.procedimentos.length > 0) this.operadora.procedimentos = item.procedimentos
    if (item.enviaCodigoUnicoMaterial) this.operadora.enviaCodigoUnicoMaterial = item.enviaCodigoUnicoMaterial
    if (item.enviaCodigoPrestadorSolicitante) this.operadora.enviaCodigoPrestadorSolicitante = item.enviaCodigoPrestadorSolicitante
    if (item.tiposDocumentoParaEnviarParaOperadora) this.operadora.tiposDocumentoParaEnviarParaOperadora = item.tiposDocumentoParaEnviarParaOperadora
  }

  @Mutation
  setOperadoras(itens: any[]) {
    this.operadoras = itens
  }

  @Mutation
  setNovoProcedimento(procedimento: any) {
    const item: any = procedimento
    item.procedimentoId = generateGUID()
    item.tipo = 'internacao'
    this.operadora.procedimentos.push(item)
  }

  @Mutation
  setEditProcedimento(procedimento: any) {
    const indexof = this.operadora.procedimentos.findIndex(c => c.codigo === procedimento.codigo)[0]
    this.operadora.procedimentos.map((c: any) => {
      const i: ProcedimentoConfiguracaoOperadora = c
      if (c.procedimentoId === procedimento.procedimentoId) {
        i.codigo = procedimento.codigo
        i.descricao = procedimento.descricao
        i.porte = procedimento.porte
        i.quantidade = procedimento.quantidade
        i.quantidadeAuxiliares = procedimento.quantidadeAuxiliares
        i.status = procedimento.status
        i.temLateralidade = procedimento.temLateralidade
        i.tipo = procedimento.tipo
        i.status = procedimento.status
        i.tipo = 'internacao'
      }
      return c
    })
  }

  @Mutation
  setProcedimento(item: any) {
    this.procedimento = item
  }

  @Mutation
  clearHospitalConfiguracaoOperadora() {
    this.hospitalConfiguracaoOperadora = { ...this.hospitalConfiguracaoOperadoraDefault }
  }

  @Mutation
  clearOperadora() {
    this.operadora = { ...this.operadora }
    this.operadora.procedimentos = []
  }

  @Mutation
  setHospitalConfiguracaoOperadoraId(id: string) {
    this.hospitalConfiguracaoOperadora.id = id
  }

  @Mutation
  clearProcedimento() {
    this.procedimento = {}
  }

  @Action
  async getHospitalConfiguracaoOperadora() {
    const response = await this.integracaoOperadoraImp.getHospitalConfiguracaoOperadora(this.hospitalId)
    const { commit } = this.context
    if (response.success) {
      commit('setHospitalConfiguracaoOperadora', response.data)
    } else {
      commit('setHospitalConfiguracaoOperadora', { ...this.hospitalConfiguracaoOperadoraDefault })
    }
    return response
  }

  @Action
  async enviarHospitalConfiguracaoOperadora() {
    const params = { ...this.hospitalConfiguracaoOperadora }
    // @ts-ignore
    if (!params.id) delete params.id
    const response = await this.integracaoOperadoraImp.enviarHospitalConfiguracaoOperadora(this.hospitalId, params)
    if (response.success) {
      const { commit } = this.context
      commit('setHospitalConfiguracaoOperadoraId', response.data)
    }
    return response
  }

  @Action
  async getAllOperadora() {
    const response = await this.integracaoOperadoraImp.getAllConvenio(this.hospitalId)
    if (response.success) {
      const { commit } = this.context
      commit('setOperadoras', response.data)
    }
  }

  @Action
  async getOperadoraById(id: string) {
    const response = await this.integracaoOperadoraImp.getConfiguracaoOperadoraById(this.hospitalId, id)
    if (response.success) {
      const { commit } = this.context
      commit('setOperadora', response.data)
    }
    return response
  }

  @Action
  async enviarOperadora() {
    const response = await this.integracaoOperadoraImp.enviarOperadora(this.hospitalId, this.operadora.convenioId, this.operadora)
    return response
  }
}
